import { IBaseDeleteRequestModel } from "../models/request/base/deleteRequest";
import { IHinhThucMienGiamRequest } from "../models/request/hinhthucmiengiam/IHinhThucMienGiamRequest";
import { sf_hinhthucmiengiam_copy_rq } from "../models/request/hinhthucmiengiam/sf_hinhthucmiengiam_copy_rq";
import { sf_hinhthucmiengiam } from "../models/response/category/sf_hinhthucmiengiam";
import { apiClient } from "./apiClient";

export const HINH_THUC_MIEN_GIAM_API_END_POINT = "sf_hinhthucmiengiam";

export const SF_HINHTHUCMIENGIAM_SELECT_API = "sf_hinhthucmiengiam/select";
export const SF_HINHTHUCMIENGIAM_INSERT_API = "sf_hinhthucmiengiam/insert";
export const SF_HINHTHUCMIENGIAM_UPDATE_API = "sf_hinhthucmiengiam/update";
export const SF_HINHTHUCMIENGIAM_DELETE_API = "sf_hinhthucmiengiam/delete";

export const SF_HINHTHUCMIENGIAM_HINHTHUCTINH_SELECT_ALL = "sf_hinhthucmiengiam_hinhthuctinh/select_all";

export const SF_HINHTHUCMIENGIAM_CHITIET_SELECT = "sf_hinhthucmiengiam_chitiet/select_by_hinhthuc";

export const SF_HINHTHUCMIENGIAM_CHITIET_SAVE_CHANGES = "sf_hinhthucmiengiam_chitiet/save_changes";
export const SF_HINHTHUCMIENGIAM_CHITIET_UPDATE = "sf_hinhthucmiengiam_chitiet/update";
export const SF_HINHTHUCMIENGIAM_CHITIET_DELETE_API = "sf_hinhthucmiengiam_chitiet/delete";

export const SF_HINHTHUCMIENGIAM_COPY = "sf_hinhthucmiengiam/copy"

export const hinhThucMienGiamApi = {
    select: (nam_hoc: string) => {
        return apiClient.post(`${SF_HINHTHUCMIENGIAM_SELECT_API}?nam_hoc=${nam_hoc}`)
    },
    insert: (data: sf_hinhthucmiengiam) => {
        return apiClient.post(`${SF_HINHTHUCMIENGIAM_INSERT_API}`, data)
    },
    update: (data: sf_hinhthucmiengiam) => {
        return apiClient.post(`${SF_HINHTHUCMIENGIAM_UPDATE_API}`, data)
    },
    delete: (data: number[]) => {
        const model: IBaseDeleteRequestModel = {
            ids: data
        }
        return apiClient.post(`${SF_HINHTHUCMIENGIAM_DELETE_API}`, model)
    },
    select_hinhthuctinhs: () => apiClient.post(SF_HINHTHUCMIENGIAM_HINHTHUCTINH_SELECT_ALL),

    select_chitiets: (sf_hinhthucmiengiam_id: number) => apiClient.post(`${SF_HINHTHUCMIENGIAM_CHITIET_SELECT}?sf_hinhthucmiengiam_id=${sf_hinhthucmiengiam_id}`),

    save_change_chitiets: (data: any) => apiClient.post(`${SF_HINHTHUCMIENGIAM_CHITIET_SAVE_CHANGES}`, data),
    save_miengiam_chitiet: (data: any) => apiClient.post(`${SF_HINHTHUCMIENGIAM_CHITIET_UPDATE}`, data),

    copy: (payload: sf_hinhthucmiengiam_copy_rq) => apiClient.post(`${SF_HINHTHUCMIENGIAM_COPY}`, payload),
    selectAllByNamHoc: (
        nam_hoc: string,
        ts_hocsinh_id: number,
        dm_coso_id: number
    ) =>
        apiClient.get(
            `${HINH_THUC_MIEN_GIAM_API_END_POINT}/select_all_by_namhoc/${nam_hoc}/${ts_hocsinh_id}/${dm_coso_id}`
        ),
    selectAllByNamHocCoso: (
        nam_hoc: string,
        dm_coso_id: number
    ) =>
        apiClient.get(
            `${HINH_THUC_MIEN_GIAM_API_END_POINT}/nam_hoc/${nam_hoc}/co_so/${dm_coso_id}`
        ),
    selectByHocSinh: (nam_hoc: string, ts_hocsinh_id: number, dm_coso_id: number) =>
        apiClient.get(
            `${HINH_THUC_MIEN_GIAM_API_END_POINT}/select_by_hocsinh/nam_hoc/${nam_hoc}/co_so/${dm_coso_id}/hoc_sinh/${ts_hocsinh_id}`
        ),

    insertDeXuatMienGiam: (request: IHinhThucMienGiamRequest) =>
        apiClient.post(
            `${HINH_THUC_MIEN_GIAM_API_END_POINT}/insert_de_xuat_mien_giam`,
            request
        ),
    deleteDeXuatMienGiam: (request: IHinhThucMienGiamRequest) =>
        apiClient.post(
            `${HINH_THUC_MIEN_GIAM_API_END_POINT}/delete_de_xuat_mien_giam`,
            request
        ),
    deleteChiTiet: (data: number) => {
        return apiClient.post(`${SF_HINHTHUCMIENGIAM_CHITIET_DELETE_API}`, data)
    },
}